import React from 'react'
 import { Blog } from '../../components/announcment/blog'

const AnnouncementPage = () => {
  return (
  <>
  <Blog />
  </>
  )
}

export default AnnouncementPage